<script setup lang="ts">
const { tt } = useTypedI18n();

const onOpenBlur = (open: boolean): void => {
    if (!open) return;

    const focusedElement = ((document.hasFocus() &&
        document.activeElement !== document.body &&
        document.activeElement !== document.documentElement &&
        document.activeElement) ||
        null) as HTMLElement | null;
    focusedElement?.blur();
};
</script>

<template>
    <BaseTooltip @update:open="onOpenBlur">
        <p ref="trigger" class="flex flex-row items-center gap-x-1">
            {{ tt('validation.hint.password.text') }} <UIcon class="text-primary mx-1 my-auto" name="lucide:info" />
        </p>

        <template #content>
            <ul class="list-disc pl-4">
                <li>{{ tt('validation.hint.password.rules.length') }}</li>
                <li>{{ tt('validation.hint.password.rules.uppercase') }}</li>
                <li>{{ tt('validation.hint.password.rules.lowercase') }}</li>
                <li>{{ tt('validation.hint.password.rules.symbol') }}</li>
                <li>{{ tt('validation.hint.password.rules.number') }}</li>
            </ul>
        </template>
    </BaseTooltip>
</template>
